module.exports = __webpack_public_path__ + "img/material_blurb2.932081cd.png";